import { Reel } from "../../types";

// O Flow compartilha o mesmo feed de reels usado pelo Paçoca Native.
export const FLOW_BUCKET: Reel["bucket"] = "reflexo";

export function createFlowReelsParams(cursor?: number | null): URLSearchParams {
    const params = new URLSearchParams({ bucket: FLOW_BUCKET });
    if (cursor) params.set("cursor", String(cursor));
    return params;
}
